import { clientThemes } from "./brandingConfig";

const { apiPrefix, apiUrl, legacyUrl, useBlackTheme } = window as any;
const THEME_CLASS = "theme-active";

const applyTheme = (theme: Record<string, string>) => {
  const root = document.documentElement;
  Object.entries(theme).forEach(([property, value]) => {
    const cssProp = property.startsWith("--") ? property : `--${property}`;
    root.style.setProperty(cssProp, value);
  });
};

const removeTheme = () => {
  const root = document.documentElement;
  [
    "--primary-color",
    "--link-color",
    "--border-color-base",
    "--background-color",
    "--error-color",
    "--warning-color",
    "--success-color",
    "--highlight-color",
    "--primary-1",
    "--primary-5",
    "--primary-6",
    "--warn-color",
    "--warn-5",
    "--background-color-base",
    "--label-color",
    "--heading-5-size",
    "--font-family",
  ].forEach((p) => root.style.removeProperty(p));
  document.body.classList.remove(THEME_CLASS);
};

export const applyOrgTheme = (organizationId?: number | null) => {
  if (useBlackTheme === "true") {
    const theme = clientThemes["BibbyMarine"];
    if (theme) {
      applyTheme(theme);
      document.body.classList.add(THEME_CLASS);
      localStorage.setItem("Theme", organizationId.toString());
    }
  } else if (
    organizationId === 64 ||
    organizationId === 65 ||
    organizationId === 66
  ) {
    const theme = clientThemes["SGS"];
    if (theme) {
      applyTheme(theme);
      document.body.classList.add(THEME_CLASS);
      localStorage.setItem("Theme", organizationId.toString());
    }
  } else {
    removeTheme();
    localStorage.setItem("Theme", "default");
  }
};
